import Api from './api.service'

import Configuration from '@/configuration';
const baseURL = Configuration.value('apiFrontend')
const baseAdminURL = Configuration.value('apiBackend')

export default {
  getVehicles(params) {
    return Api().get(`${baseAdminURL}/exchange/vehicle`, { params })
  },
  getVehicle(id) {
    return Api().get(`${baseAdminURL}/exchange/vehicle/${id}`)
  },
  storeVehicle(payload) {
    return Api().post(`${baseAdminURL}/exchange/vehicle`, payload)
  },
  updateVehicle(id, payload) {
    return Api().put(`${baseAdminURL}/exchange/vehicle/${id}`, payload)
  },
  deleteVehicle(id) {
    return Api().delete(`${baseAdminURL}/exchange/vehicle/${id}`)
  },
  getMakeModels() {
    return Api().get(`${baseAdminURL}/exchange/refdata/makemodels`)
  },
  getFueltypes() {
    return Api().get(`${baseAdminURL}/exchange/refdata/fueltypes`)
  },
  getList(params) {
    return Api().get(`${baseURL}/exchange/vehicle`, { params })
  },
  createOffer(vehicleId, payload) {
    return Api().post(`${baseURL}/exchange/vehicle/offer/${vehicleId}`, payload)
  }
}
